export default "__VITE_ASSET__D2w8Ry_7__"